import React from "react";
import { useSelector } from "react-redux";
import { selectJobDetailsSection } from "../../../redux/selectors";

const PrintGeneral = () => {
  const generalStationDetails = useSelector((state) =>
    selectJobDetailsSection(state, "generalStation")
  );

  const renderDetails = (details, sectionName) => {
    // Ensure details is defined, is an array, and has non-empty elements
    if (!details || !Array.isArray(details) || details.length === 0) {
      return null; // If the details are empty, do not render anything
    }

    return (
      <div>
        {details
          .filter(detail => detail && Object.keys(detail).length > 0) // Ensure non-empty details
          .map((detail, index) => (
            <div className="section" key={index}>
              <table className="table table-bordered full-width">
                <tbody>
                  <h3 className="print-zone-label">Zone: {detail.Zone}</h3>
                  <tr>
                    <td className="col-md-6">
                      <table>
                        <tbody>
                          <tr><td><strong>Station Type: </strong>{detail.StationType}</td></tr>
                          <tr><td><strong>Station Configuration: </strong>{detail.StationConfiguration}</td></tr>
                          <tr><td><strong>Prime System: </strong>{detail.PrimeSystem}</td></tr>
                          <tr><td><strong>Dynamic Inlet PSI: </strong>{detail.DynamicInletPSI}</td></tr>
                          <tr><td><strong>Regulatory Compliance: </strong>{detail.RegulatoryCompliance}</td></tr>
                          <tr><td><strong>Station Location: </strong>{detail.StationLocation}</td></tr>
                          <tr><td><strong>Site Elevation (ft): </strong>{detail.SiteElevation}</td></tr>
                          <tr><td><strong>Color: </strong>{detail.Color}</td></tr>
                          <tr><td><strong>Flow Meter Location: </strong>{detail.FlowMeterLocation}</td></tr>
                        </tbody>
                      </table>
                    </td>
                    <td className="col-md-6">
                      <table>
                        <tbody>
                          <tr><td><strong>Site Voltage: </strong>{detail.SiteVoltage}</td></tr>
                          <tr><td><strong>Power Configuration: </strong>{detail.PowerConfiguration}</td></tr>
                          <tr><td><strong>SCCR Rating: </strong>{detail.SCCRRating}</td></tr>
                          <tr><td><strong>FCC Type: </strong>{detail.FCCType}</td></tr>
                          <tr><td><strong>Feet of Lift: </strong>{detail.FeetOfLift}</td></tr>
                          <tr><td><strong>Discharge PSI: </strong>{detail.DischargePSI}</td></tr>
                          <tr><td><strong>Total GPM: </strong>{detail.TotalGPM}</td></tr>
                          <tr><td><strong>Wet Well Depth: </strong>{detail.WetWellDepth}</td></tr>
                          <tr><td><strong>Electrical Enclosure Location: </strong>{detail.ElectricalEnclosureLocation}</td></tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
              <p><strong>Comments:</strong><br />{detail.Comments}</p>
              <br className="clearfix" />
            </div>
          ))}
      </div>
    );
  };

  return (
    <div>
      <h2 className="print-section-header">Station Summary</h2>
      {renderDetails(generalStationDetails, "generalStation")}
    </div>
  );
};

export default PrintGeneral;
